/**
 * "No JSA for today" on a well card. Rig services: only when a rig is
 * working on that well today (never an idle or customer well with no crew
 * on location). Operators: as before (every well on the board).
 */
export function showNoJsaWarning({ wellId, serviceCompany, workingWellIds }) {
  if (!serviceCompany) return true;
  return !!workingWellIds && workingWellIds.has(String(wellId));
}
